import script from "./EditCreateProgramDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditCreateProgramDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditCreateProgramDialog.vue?vue&type=style&index=0&id=9e0b5ec6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e0b5ec6"]])

export default __exports__